import '../styles.scss'

import { useAppSelector } from '@/store/hook'
import {
  selectCartTotalVAT,
  selectCartTotalWithoutVAT,
  selectCurrencyUnit,
  selectIsIncludingVAT,
  selectSalesOrderNumber,
  selectVAT,
} from '@/store/selectors/checkoutSelector'

import OrderSummary from './OrderSummary'

const MiddleSectionComponent = () => {
  const cartTotal = useAppSelector(selectCartTotalWithoutVAT)
  const salesOrderNumber = useAppSelector(selectSalesOrderNumber)
  const currencyUnit = useAppSelector(selectCurrencyUnit)
  const isIncludingVAT = useAppSelector(selectIsIncludingVAT)
  const vat = useAppSelector(selectVAT)
  const cartTotalVAT = useAppSelector(selectCartTotalVAT)

  return (
    <OrderSummary
      cartTotal={cartTotal}
      cartTotalVAT={cartTotalVAT}
      currencyUnit={currencyUnit}
      includingVAT={isIncludingVAT}
      salesOrderNumber={salesOrderNumber}
      vat={vat}
    />
  )
}
export default MiddleSectionComponent
